// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"230":"06e2ee59","318":"87741468","671":"348e9c10","782":"e848ad63"}[chunkId] + ".chunk.css";
};